import React from "react"
import { Menu as MenuPrimitive } from "@base-ui/react/menu"
import { popupTransition } from "../utils/popup-transition"

export type MenuContentProps = {
  /** Menu items and other content */
  children?: React.ReactNode
  /** Side the menu opens relative to the trigger */
  side?: "top" | "bottom" | "left" | "right"
  /** Alignment of the menu relative to the trigger */
  align?: "start" | "center" | "end"
  /** Gap in pixels between the trigger and menu */
  sideOffset?: number
  /** Offset in pixels along the alignment axis */
  alignOffset?: number
  /** When true, the menu content matches the trigger width exactly */
  matchTriggerWidth?: boolean
}

const contentStyles = [
  "min-w-[200px] overflow-hidden rounded-[12px] p-1",
  "bg-white border border-gray-200 shadow-[0px_4px_8px_0px_rgba(30,30,30,0.12)]",
  // Entry/exit transition
  popupTransition()
].join(" ")

export function MenuContent({
  children,
  side = "bottom",
  align = "start",
  sideOffset = 4,
  alignOffset,
  matchTriggerWidth
}: MenuContentProps) {
  return (
    <MenuPrimitive.Portal>
      <MenuPrimitive.Positioner
        side={side}
        align={align}
        sideOffset={sideOffset}
        alignOffset={alignOffset}
        className="z-[5001]"
      >
        <MenuPrimitive.Popup
          data-slot="menu-content"
          className={contentStyles}
          style={
            matchTriggerWidth ? { width: "var(--anchor-width)" } : undefined
          }
        >
          {children}
        </MenuPrimitive.Popup>
      </MenuPrimitive.Positioner>
    </MenuPrimitive.Portal>
  )
}

MenuContent.displayName = "Menu.Content"
